/* Product Text Customizer - Canvas Based */
(function() {
  var CUSTOMIZE_VARIANT_NAME = 'Customize';
  var MAX_TOTAL_CHARS = 80;
  var MAX_SECOND_TEXT_CHARS = 120;
  var isLogoSizeValid = true; // Flag to track logo file size validity

  function initCustomizer() {
    var container = document.querySelector('.product-customizer');
    if (!container) return;
   
    var textInput = container.querySelector('.product-customizer__input');
    var textInput2 = container.querySelector('.product-customizer__input-secondary');
var charCount2 = container.querySelector('.product-customizer__char-count-secondary');
var hiddenText2 = container.querySelector('input[name="properties[Second Text]"]');
    var fontSelect = container.querySelector('input.product-customizer__font-select');
    var fontDropdown = container.querySelector('.product-customizer__font-dropdown');
    var fontSelectedBtn = container.querySelector('.product-customizer__font-selected');
    var fontSelectedImg = container.querySelector('.product-customizer__font-selected-img');
    var fontOptions = container.querySelector('.product-customizer__font-options');
    var charCount = container.querySelector('.product-customizer__char-count');
    var previewWrapper = container.querySelector('.product-customizer__preview-wrapper');
    var previewImage = container.querySelector('.product-customizer__preview-img');
    var previewCanvas = container.querySelector('.product-customizer__preview-canvas');
    var canvasCtx = previewCanvas ? previewCanvas.getContext('2d') : null;
    
    var hiddenText = container.querySelector('input[name="properties[Custom Text]"]');
    var hiddenFont = container.querySelector('input[name="properties[Font]"]');
    var hiddenFontSize = container.querySelector('input[name="properties[_Font Size]"]');
    var hiddenPosition = container.querySelector('input[name="properties[_Text Position]"]');
    var hiddenImage = container.querySelector('input[name="properties[Selected Image]"]');
    var hiddenImageUrl = container.querySelector('input[name="properties[_Selected Image URL]"]');
    var hiddenPreview = container.querySelector('input[name="properties[_Preview Image]"]');
    var hiddenPreviewUrl = container.querySelector('input[name="properties[Preview Image URL]"]');
    var swatchContainer = container.querySelector('.product-customizer__swatch-items');
    var swatchLabel = container.querySelector('.product-customizer__swatch-label');

    // Logo upload elements
    var logoSection = container.querySelector('.product-customizer__logo-section');
    var logoToggle = container.querySelector('.product-customizer__toggle-input');
    var logoUploadSection = container.querySelector('.product-customizer__logo-upload');
    var logoFileInput = container.querySelector('.product-customizer__file-input');
    var hiddenLogoEnabled = container.querySelector('input[name="properties[Logo Enabled]"]');
    var hiddenLogoData = container.querySelector('input[name="properties[_Logo Data]"]');
    var hiddenLogoUrl = container.querySelector('input[name="properties[Logo URL]"]');
    var hiddenLogoPosition = container.querySelector('input[name="properties[_Logo Position]"]');
    var hiddenLogoSize = container.querySelector('input[name="properties[_Logo Size]"]');
    var hiddenLogoPrice = container.querySelector('input[name="properties[_Logo Price]"]');

    // Gift wrap elements
    var giftWrapSection = container.querySelector('.product-customizer__gift-wrap-section');
    var giftWrapToggle = container.querySelector('.product-customizer__gift-wrap-toggle');
    var hiddenGiftWrap = container.querySelector('input[name="properties[Gift Wrap]"]');
    var hiddenGiftWrapPrice = container.querySelector('input[name="properties[_Gift Wrap Price]"]');

    // Markers elements
    var markersSection = container.querySelector('.product-customizer__markers-section');
    var markersToggle = container.querySelector('.product-customizer__markers-toggle');
    var hiddenMarkers = container.querySelector('input[name="properties[Markers]"]');
    var hiddenMarkersPrice = container.querySelector('input[name="properties[_Markers Price]"]');

    if (!textInput || !previewCanvas) return;

    var isCustomizeActive = false;
    var variantSwatchesData = {};
    var baseImage = null;
    var logoImage = null;

    // Canvas element states
    var textElement = {
      text: '',
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      fontSize: 55,
      font: 'Libre Baskerville',
      visible: false
    };
    var textElement2 = {
  text: '',
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  fontSize: 55,
  font: 'Libre Baskerville',
  visible: false
};

    var logoElement = {
      x: 0,
      y: 0,
      width: 100,
      height: 100,
      visible: false,
      enabled: false
    };

    var selectedElement = null; // 'text' or 'logo'
    var isDragging = false;
    var isResizing = false;
    var activeHandle = null; // 'tl', 'tr', 'bl', 'br'
    var dragStartX = 0;
    var dragStartY = 0;
    var elementStartX = 0;
    var elementStartY = 0;
    var elementStartWidth = 0;
    var elementStartHeight = 0;
    var elementStartFontSize = 0;
    var isRenderingForPreview = false; // Hide UI elements for cart preview

    // Board safe zone
    var BOARD_LEFT_PCT = 0.17;
    var BOARD_TOP_PCT = 0.02;
    var BOARD_WIDTH_PCT = 0.65;
    var BOARD_HEIGHT_PCT = 0.92;

    // Per-product layouts (landscape boards). Fractions of the style image.
    // Each style: name zone where the customer's text is placed and fitted.
    var PRODUCT_LAYOUTS = {
      'glowrite-pro-led-desk-planner-with-15w-wireless-charging': {
        board: { left: 0.025, top: 0.025, width: 0.95, height: 0.95 },
        styles: [
          { match: /twin/i,               zone: { l: 0.0393, t: 0.0432, r: 0.4786, b: 0.2153 }, align: 'center',
                                          zone2: { l: 0.5190, t: 0.0432, r: 0.9630, b: 0.2153 }, align2: 'center' },
          { match: /today|this.?week/i,   zone: { l: 0.0470, t: 0.0366, r: 0.4810, b: 0.1491 }, align: 'left',
                                          zone2: { l: 0.5854, t: 0.0349, r: 0.9630, b: 0.1078 }, align2: 'right' },
          { match: /daily/i,              zone: { l: 0.0440, t: 0.0432, r: 0.4953, b: 0.1392 }, align: 'center' },
          { match: /blank/i,              zone: { l: 0.0464, t: 0.0457, r: 0.9513, b: 0.2733 }, align: 'left' }
        ]
      }
    };
    var currentLayout = (function() {
      var handle = window.MinimogSettings && window.MinimogSettings.productHandle;
      return (handle && PRODUCT_LAYOUTS[handle]) || null;
    })();
    var currentBaseSrc = '';
    var textUserMoved = false;
    var text2UserMoved = false;

    function getStyleLayout() {
      if (!currentLayout) return null;
      var file = (currentBaseSrc || '').split('?')[0].split('/').pop();
      for (var i = 0; i < currentLayout.styles.length; i++) {
        if (currentLayout.styles[i].match.test(file)) return currentLayout.styles[i];
      }
      return null;
    }

    // Fit an element's text inside a zone (fractions of the image) and align it
    function fitInZone(el, zone, align) {
      var W = previewCanvas.width, H = previewCanvas.height;
      var zl = W * zone.l, zt = H * zone.t;
      var zw = W * (zone.r - zone.l), zh = H * (zone.b - zone.t);
      var size = 55;
      var dims = measureText(el.text, size, el.font);
      for (var i = 0; i < 40 && (dims.width > zw || dims.height > zh) && size > 10; i++) {
        size = Math.max(10, size * 0.95);
        dims = measureText(el.text, size, el.font);
      }
      el.fontSize = size;
      el.width = dims.width;
      el.height = dims.height;
      el.x = align === 'center' ? zl + (zw - dims.width) / 2 : align === 'right' ? zl + zw - dims.width : zl;
      el.y = zt + Math.max(0, (zh - dims.height) / 2);
    }

    // Place and fit the main text inside the style's name zone
    function placeTextInZone() {
      var style = getStyleLayout();
      if (!style || !textElement.text) return false;
      fitInZone(textElement, style.zone, style.align);
      updateHiddenFields();
      return true;
    }

    // Place the second text (message) on the second board, if the style has one
    function placeText2InZone() {
      var style = getStyleLayout();
      if (!style || !style.zone2 || !textElement2.text) return false;
      fitInZone(textElement2, style.zone2, style.align2);
      return true;
    }

    // Show the "Write your Message" box only for styles with two boards
    function updateSecondInputVisibility() {
      if (!currentLayout || !textInput2) return;
      var style = getStyleLayout();
      var show = !!(style && style.zone2);
      var nodes = [textInput2, charCount2];
      var prev = textInput2.previousElementSibling;
      for (var i = 0; i < 2 && prev; i++) { nodes.push(prev); prev = prev.previousElementSibling; }
      nodes.forEach(function(n) { if (n) n.style.display = show ? '' : 'none'; });
      if (!show && textElement2.text) {
        textInput2.value = '';
        textElement2.text = '';
        textElement2.visible = false;
        if (hiddenText2) hiddenText2.value = '';
        if (charCount2) charCount2.textContent = MAX_SECOND_TEXT_CHARS + ' character(s) left';
      }
    }

    // Faint placeholder showing where the name will go
    var WATERMARK_TEXT = 'Your Name';
    function drawNameWatermark() {
      var style = getStyleLayout();
      if (!style || !canvasCtx) return;
      var W = previewCanvas.width, H = previewCanvas.height;
      var zl = W * style.zone.l, zt = H * style.zone.t;
      var zw = W * (style.zone.r - style.zone.l), zh = H * (style.zone.b - style.zone.t);
      var font = textElement.font || 'Libre Baskerville';
      var size = 55;
      var dims = measureText(WATERMARK_TEXT, size, font);
      while ((dims.width > zw || dims.height > zh) && size > 10) {
        size = size * 0.95;
        dims = measureText(WATERMARK_TEXT, size, font);
      }
      var x = style.align === 'center' ? zl + (zw - dims.width) / 2 : zl;
      var y = zt + Math.max(0, (zh - dims.height) / 2);
      canvasCtx.save();
      canvasCtx.font = size + 'px ' + font;
      canvasCtx.fillStyle = 'rgba(255,255,255,0.28)';
      canvasCtx.textBaseline = 'top';
      canvasCtx.fillText(WATERMARK_TEXT, x, y);
      canvasCtx.setLineDash([8, 6]);
      canvasCtx.lineWidth = 2;
      canvasCtx.strokeStyle = 'rgba(255,255,255,0.22)';
      canvasCtx.strokeRect(zl - 8, zt - 4, zw + 16, zh + 8);
      canvasCtx.restore();
    }

    function drawZoneWatermark(label, zone, align) {
      var W = previewCanvas.width, H = previewCanvas.height;
      var zl = W * zone.l, zt = H * zone.t;
      var zw = W * (zone.r - zone.l), zh = H * (zone.b - zone.t);
      var font = textElement.font || 'Libre Baskerville';
      var size = 55;
      var dims = measureText(label, size, font);
      while ((dims.width > zw || dims.height > zh) && size > 10) {
        size = size * 0.95;
        dims = measureText(label, size, font);
      }
      var x = align === 'center' ? zl + (zw - dims.width) / 2 : align === 'right' ? zl + zw - dims.width : zl;
      var y = zt + Math.max(0, (zh - dims.height) / 2);
      canvasCtx.save();
      canvasCtx.font = size + 'px ' + font;
      canvasCtx.fillStyle = 'rgba(255,255,255,0.28)';
      canvasCtx.textBaseline = 'top';
      canvasCtx.fillText(label, x, y);
      canvasCtx.setLineDash([8, 6]);
      canvasCtx.lineWidth = 2;
      canvasCtx.strokeStyle = 'rgba(255,255,255,0.22)';
      canvasCtx.strokeRect(zl - 8, zt - 4, zw + 16, zh + 8);
      canvasCtx.restore();
    }

    // Helper to get board bounds in canvas coordinates
    function getBoardBounds() {
      var canvasW = previewCanvas.width;
      var canvasH = previewCanvas.height;
      if (currentLayout) {
        var b = currentLayout.board;
        return { left: canvasW * b.left, top: canvasH * b.top, width: canvasW * b.width, height: canvasH * b.height };
      }
      return {
        left: canvasW * BOARD_LEFT_PCT,
        top: canvasH * BOARD_TOP_PCT,
        width: canvasW * BOARD_WIDTH_PCT,
        height: canvasH * BOARD_HEIGHT_PCT
      };
    }

    // Helper to get mouse position relative to canvas
    function getCanvasCoords(e) {
      var rect = previewCanvas.getBoundingClientRect();
      var scaleX = previewCanvas.width / rect.width;
      var scaleY = previewCanvas.height / rect.height;
      
      var clientX, clientY;
      if (e.touches && e.touches.length > 0) {
        clientX = e.touches[0].clientX;
        clientY = e.touches[0].clientY;
      } else if (e.changedTouches && e.changedTouches.length > 0) {
        // For touchend, use changedTouches
        clientX = e.changedTouches[0].clientX;
        clientY = e.changedTouches[0].clientY;
      } else if (e.clientX !== undefined) {
        clientX = e.clientX;
        clientY = e.clientY;
      } else {
        // Fallback - return last known position or center
        return { x: 0, y: 0 };
      }
      
      return {
        x: (clientX - rect.left) * scaleX,
        y: (clientY - rect.top) * scaleY
      };
    }

    // Measure text dimensions
    function measureText(text, fontSize, font) {
      canvasCtx.font = fontSize + 'px ' + font;
      var lines = text.split('\n');
      var maxWidth = 0;
      lines.forEach(function(line) {
        var metrics = canvasCtx.measureText(line);
        if (metrics.width > maxWidth) maxWidth = metrics.width;
      });
      var lineHeight = fontSize * 1.2;
      var height = lines.length * lineHeight;
      return { width: maxWidth, height: height };
    }

    // Hit detection for resize handles
    function hitTestHandle(x, y, element) {
      var handleSize = 24; // Visual size
      var touchPadding = 12; // Extra touch area around handle (invisible)
      var touchAreaSize = handleSize + (touchPadding * 2); // Total touch area = 48px
      
      var handles = [
        { name: 'tl', x: element.x, y: element.y },
        { name: 'tr', x: element.x + element.width, y: element.y },
        { name: 'bl', x: element.x, y: element.y + element.height },
        { name: 'br', x: element.x + element.width, y: element.y + element.height }
      ];
      
      for (var i = 0; i < handles.length; i++) {
        var h = handles[i];
        // Use larger touch area for better mobile interaction
        if (x >= h.x - touchAreaSize/2 && x <= h.x + touchAreaSize/2 &&
            y >= h.y - touchAreaSize/2 && y <= h.y + touchAreaSize/2) {
          return h.name;
        }
      }
      return null;
    }

    // Hit detection for elements
    function hitTestElement(x, y) {
  // ✅ Check 2nd text first (important when overlap)
  if (textElement2 && textElement2.visible &&
      x >= textElement2.x && x <= textElement2.x + textElement2.width &&
      y >= textElement2.y && y <= textElement2.y + textElement2.height) {
    return 'text2';
  }

  if (textElement.visible &&
      x >= textElement.x && x <= textElement.x + textElement.width &&
      y >= textElement.y && y <= textElement.y + textElement.height) {
    return 'text';
  }

  if (logoElement.visible &&
      x >= logoElement.x && x <= logoElement.x + logoElement.width &&
      y >= logoElement.y && y <= logoElement.y + logoElement.height) {
    return 'logo';
  }

  return null;
}
function snapSecondTextToBottom() {
  if (!textElement2.visible || !textElement2.text) return;
  if (currentLayout) {
    if (!text2UserMoved) placeText2InZone();
    return;
  }

  var bounds = getBoardBounds();
  var paddingX = bounds.width * 0.02;
  var paddingY = bounds.height * 0.03;

  var dims2 = measureText(textElement2.text, textElement2.fontSize, textElement2.font);
  textElement2.width = dims2.width;
  textElement2.height = dims2.height;

  textElement2.x = bounds.left + paddingX;
  textElement2.y = (bounds.top + bounds.height) - textElement2.height - paddingY;

  clampElementPosition(textElement2);
}

    // Render canvas
function renderCanvas() {
  if (!canvasCtx || !baseImage) return;

  canvasCtx.imageSmoothingEnabled = true;
  canvasCtx.imageSmoothingQuality = 'high';

  canvasCtx.clearRect(0, 0, previewCanvas.width, previewCanvas.height);
  canvasCtx.drawImage(baseImage, 0, 0, previewCanvas.width, previewCanvas.height);

  // Watermark: faint "Your Name" in the name area until the customer types
  if (!isRenderingForPreview && !(textElement.visible && textElement.text)) {
    drawNameWatermark();
  }
  if (!isRenderingForPreview && textInput2 && !(textElement2.visible && textElement2.text)) {
    var wmStyle = getStyleLayout();
    if (wmStyle && wmStyle.zone2) drawZoneWatermark('Your Message', wmStyle.zone2, wmStyle.align2);
  }

  // Logo
  if (logoElement.visible && logoImage) {
    canvasCtx.drawImage(logoImage, logoElement.x, logoElement.y, logoElement.width, logoElement.height);
  }

  // Text 1
  if (textElement.visible && textElement.text) {
    canvasCtx.save();
    canvasCtx.font = textElement.fontSize + 'px ' + textElement.font;
    canvasCtx.fillStyle = '#ffffff';
    canvasCtx.shadowColor = 'rgba(0,0,0,0.5)';
    canvasCtx.shadowBlur = 3;
    canvasCtx.shadowOffsetX = 1;
    canvasCtx.shadowOffsetY = 1;
    canvasCtx.textBaseline = 'top';

    var lines = textElement.text.split('\n');
    var lineHeight = textElement.fontSize * 1.2;
    lines.forEach(function(line, i) {
      canvasCtx.fillText(line, textElement.x, textElement.y + (i * lineHeight));
    });
    canvasCtx.restore();
  }

  // Text 2
  if (textElement2.visible && textElement2.text) {
    canvasCtx.save();
    canvasCtx.font = textElement2.fontSize + 'px ' + textElement2.font;
    canvasCtx.fillStyle = '#ffffff';
    canvasCtx.shadowColor = 'rgba(0,0,0,0.5)';
    canvasCtx.shadowBlur = 3;
    canvasCtx.shadowOffsetX = 1;
    canvasCtx.shadowOffsetY = 1;
    canvasCtx.textBaseline = 'top';

    var lines2 = textElement2.text.split('\n');
    var lineHeight2 = textElement2.fontSize * 1.2;
    lines2.forEach(function(line, i) {
      canvasCtx.fillText(line, textElement2.x, textElement2.y + (i * lineHeight2));
    });
    canvasCtx.restore();
  }

  // --- UI (borders + handles) ---
  if (isRenderingForPreview) return;

  // Logo UI
  if (logoElement.visible && logoImage) {
    var colorL = '#2196F3';
    canvasCtx.strokeStyle = colorL;
    canvasCtx.lineWidth = (selectedElement === 'logo') ? 2 : 1;
    canvasCtx.setLineDash([5, 5]);
    canvasCtx.strokeRect(logoElement.x, logoElement.y, logoElement.width, logoElement.height);
    canvasCtx.setLineDash([]);

    var hs = 24;
    var handlesL = [
      { x: logoElement.x, y: logoElement.y },
      { x: logoElement.x + logoElement.width, y: logoElement.y },
      { x: logoElement.x, y: logoElement.y + logoElement.height },
      { x: logoElement.x + logoElement.width, y: logoElement.y + logoElement.height }
    ];
    canvasCtx.fillStyle = colorL;
    handlesL.forEach(function(h) {
      canvasCtx.fillRect(h.x - hs/2, h.y - hs/2, hs, hs);
    });
  }

  // Text 1 UI
  if (textElement.visible && textElement.text) {
    var colorT = '#e88a1a';
    canvasCtx.strokeStyle = colorT;
    canvasCtx.lineWidth = (selectedElement === 'text') ? 2 : 1;
    canvasCtx.setLineDash([5, 5]);
    canvasCtx.strokeRect(textElement.x, textElement.y, textElement.width, textElement.height);
    canvasCtx.setLineDash([]);

    var hs1 = 24;
    var handlesT = [
      { x: textElement.x, y: textElement.y },
      { x: textElement.x + textElement.width, y: textElement.y },
      { x: textElement.x, y: textElement.y + textElement.height },
      { x: textElement.x + textElement.width, y: textElement.y + textElement.height }
    ];
    canvasCtx.fillStyle = colorT;
    handlesT.forEach(function(h) {
      canvasCtx.fillRect(h.x - hs1/2, h.y - hs1/2, hs1, hs1);
    });
  }

  // Text 2 UI
  if (textElement2.visible && textElement2.text) {
    var colorT2 = '#e88a1a';
    canvasCtx.strokeStyle = colorT2;
    canvasCtx.lineWidth = (selectedElement === 'text2') ? 2 : 1;
    canvasCtx.setLineDash([5, 5]);
    canvasCtx.strokeRect(textElement2.x, textElement2.y, textElement2.width, textElement2.height);
    canvasCtx.setLineDash([]);

    var hs2 = 24;
    var handlesT2 = [
      { x: textElement2.x, y: textElement2.y },
      { x: textElement2.x + textElement2.width, y: textElement2.y },
      { x: textElement2.x, y: textElement2.y + textElement2.height },
      { x: textElement2.x + textElement2.width, y: textElement2.y + textElement2.height }
    ];
    canvasCtx.fillStyle = colorT2;
    handlesT2.forEach(function(h) {
      canvasCtx.fillRect(h.x - hs2/2, h.y - hs2/2, hs2, hs2);
    });
  }
}
    // Auto-fit text within board bounds
    function autoFitTextToBoard() {
      if (!textElement.visible || !textElement.text) return;
      if (!textUserMoved && placeTextInZone()) return;
      
      var bounds = getBoardBounds();
      var maxIterations = 20;
      var iteration = 0;
      
      // Keep reducing font size until text fits within board
      while (iteration < maxIterations) {
        var dims = measureText(textElement.text, textElement.fontSize, textElement.font);
        textElement.width = dims.width;
        textElement.height = dims.height;
        
        // Check if text fits within board bounds
        var fitsHorizontally = (textElement.x + textElement.width) <= (bounds.left + bounds.width);
        var fitsVertically = (textElement.y + textElement.height) <= (bounds.top + bounds.height);
        
        if (fitsHorizontally && fitsVertically) {
          break; // Text fits, we're done
        }
        
        // Reduce font size by 5% and try again
        textElement.fontSize = Math.max(10, textElement.fontSize * 0.95);
        iteration++;
      }
      
      // Update final dimensions
      var finalDims = measureText(textElement.text, textElement.fontSize, textElement.font);
      textElement.width = finalDims.width;
      textElement.height = finalDims.height;
      
      // Ensure position is still within bounds
      clampElementPosition(textElement);
    }

    // Clamp element position within board bounds
    function clampElementPosition(element) {
      var bounds = getBoardBounds();
      
      // Ensure element stays within left and top bounds
      if (element.x < bounds.left) element.x = bounds.left;
      if (element.y < bounds.top) element.y = bounds.top;
      
      // Ensure element stays within right and bottom bounds
      if (element.x + element.width > bounds.left + bounds.width) {
        element.x = bounds.left + bounds.width - element.width;
      }
      if (element.y + element.height > bounds.top + bounds.height) {
        element.y = bounds.top + bounds.height - element.height;
      }
      
      // Double check - if width/height is larger than board, shrink it
      if (element.width > bounds.width) {
        element.width = bounds.width;
        element.x = bounds.left;
      }
      if (element.height > bounds.height) {
        element.height = bounds.height;
        element.y = bounds.top;
      }
      
      // Final boundary check
      if (element.x < bounds.left) element.x = bounds.left;
      if (element.y < bounds.top) element.y = bounds.top;
    }

    // Update hidden form fields from element positions
    function updateHiddenFields() {
      var bounds = getBoardBounds();
      
      if (textElement.visible) {
        var percentX = Math.round(((textElement.x - bounds.left) / bounds.width) * 100);
        var percentY = Math.round(((textElement.y - bounds.top) / bounds.height) * 100);
        if (hiddenPosition) hiddenPosition.value = percentX + '% from left, ' + percentY + '% from top';
        if (hiddenFontSize) hiddenFontSize.value = textElement.fontSize;
      }
      
      if (logoElement.visible) {
        var centerX = logoElement.x + logoElement.width / 2;
        var centerY = logoElement.y + logoElement.height / 2;
        var percentX = Math.round(((centerX - bounds.left) / bounds.width) * 100);
        var percentY = Math.round(((centerY - bounds.top) / bounds.height) * 100);
        if (hiddenLogoPosition) hiddenLogoPosition.value = percentX + '% from left, ' + percentY + '% from top';
        if (hiddenLogoSize) hiddenLogoSize.value = logoElement.width;
      }
    }

    // Canvas mouse/touch event handlers
    function onCanvasMouseDown(e) {
      // Prevent default for all touch events to avoid scrolling
      if (e.type.indexOf('touch') !== -1) {
        e.preventDefault();
      }
      var coords = getCanvasCoords(e);
      if (!coords || coords.x === undefined) return;
      
      // Check if clicking on a handle of any visible element
      // Check logo handles first
      if (logoElement.visible && logoImage) {
        var logoHandle = hitTestHandle(coords.x, coords.y, logoElement);
        if (logoHandle) {
          selectedElement = 'logo';
          isResizing = true;
          activeHandle = logoHandle;
          dragStartX = coords.x;
          dragStartY = coords.y;
          elementStartX = logoElement.x;
          elementStartY = logoElement.y;
          elementStartWidth = logoElement.width;
          elementStartHeight = logoElement.height;
          renderCanvas();
          return;
        }
      }
      // Check SECOND text handles
if (textElement2.visible && textElement2.text) {
  var text2Handle = hitTestHandle(coords.x, coords.y, textElement2);
  if (text2Handle) {
    selectedElement = 'text2';
    isResizing = true;
    text2UserMoved = true;
    activeHandle = text2Handle;
    dragStartX = coords.x;
    dragStartY = coords.y;
    elementStartX = textElement2.x;
    elementStartY = textElement2.y;
    elementStartWidth = textElement2.width;
    elementStartHeight = textElement2.height;
    elementStartFontSize = textElement2.fontSize;
    renderCanvas();
    return;
  }
}
      
      // Check text handles
      if (textElement.visible && textElement.text) {
        var textHandle = hitTestHandle(coords.x, coords.y, textElement);
        if (textHandle) {
          selectedElement = 'text';
          isResizing = true;
          textUserMoved = true;
          activeHandle = textHandle;
          dragStartX = coords.x;
          dragStartY = coords.y;
          elementStartX = textElement.x;
          elementStartY = textElement.y;
          elementStartWidth = textElement.width;
          elementStartHeight = textElement.height;
          elementStartFontSize = textElement.fontSize;
          renderCanvas();
          return;
        }
      }
      
      // Check if clicking on an element
      var hitElement = hitTestElement(coords.x, coords.y);
      if (hitElement) {
        selectedElement = hitElement;
        isDragging = true;
        if (hitElement === 'text') textUserMoved = true;
        if (hitElement === 'text2') text2UserMoved = true;
        var elem =
  selectedElement === 'text' ? textElement :
  selectedElement === 'text2' ? textElement2 :
  logoElement;
        dragStartX = coords.x;
        dragStartY = coords.y;
        elementStartX = elem.x;
        elementStartY = elem.y;
        renderCanvas();
        return;
      }
      
      // Clicked on empty space, deselect
      selectedElement = null;
      renderCanvas();
    }

    function onCanvasMouseMove(e) {
      // Prevent scrolling during touch drag/resize
      if ((isDragging || isResizing) && e.type.indexOf('touch') !== -1) {
        e.preventDefault();
      }
      
      if (!isDragging && !isResizing) {
        // Update cursor based on hover
        var coords = getCanvasCoords(e);
        var cursor = 'default';
        
        // Check handles on any visible element
        var foundHandle = false;
        
        // Check logo handles
        if (logoElement.visible && logoImage) {
          var logoHandle = hitTestHandle(coords.x, coords.y, logoElement);
          if (logoHandle) {
            if (logoHandle === 'tl' || logoHandle === 'br') cursor = 'nwse-resize';
            else cursor = 'nesw-resize';
            foundHandle = true;
          }
        }
        
        // Check text handles if no logo handle found
        if (!foundHandle && textElement.visible && textElement.text) {
          var textHandle = hitTestHandle(coords.x, coords.y, textElement);
          if (textHandle) {
            if (textHandle === 'tl' || textHandle === 'br') cursor = 'nwse-resize';
            else cursor = 'nesw-resize';
            foundHandle = true;
          }
        }
        
        // Check element hit if no handle found
        if (!foundHandle) {
          var hitElement = hitTestElement(coords.x, coords.y);
          if (hitElement) {
            cursor = selectedElement ? 'move' : 'pointer';
          }
        }
        
        previewCanvas.style.cursor = cursor;
        return;
      }
      
      var coords = getCanvasCoords(e);
      if (!coords || coords.x === undefined) return;
      
      var elem =
  selectedElement === 'text' ? textElement :
  selectedElement === 'text2' ? textElement2 :
  logoElement;
      var bounds = getBoardBounds();
      
      if (isResizing) {
        var dx = coords.x - dragStartX;
        var dy = coords.y - dragStartY;
        var bounds = getBoardBounds();
        
       if (selectedElement === 'text' || selectedElement === 'text2') {

  var targetText = (selectedElement === 'text2') 
      ? textElement2 
      : textElement;
          // Calculate the scaling factor based on handle direction
          var scaleFactor = 1;
          
          if (activeHandle === 'br' || activeHandle === 'tr') {
            scaleFactor = 1 + (dx / elementStartWidth);
          } else if (activeHandle === 'bl' || activeHandle === 'tl') {
            scaleFactor = 1 - (dx / elementStartWidth);
          }
          
          scaleFactor = Math.max(0.5, Math.min(5, scaleFactor));
          var newFontSize = Math.max(10, Math.min(200, elementStartFontSize * scaleFactor));
targetText.fontSize = newFontSize;

var dims = measureText(targetText.text, targetText.fontSize, targetText.font);
targetText.width = dims.width;
targetText.height = dims.height;
          
          // Calculate anchor point based on handle
          var anchorX, anchorY;
          if (activeHandle === 'br') {
            anchorX = elementStartX;
            anchorY = elementStartY;
          } else if (activeHandle === 'bl') {
            anchorX = elementStartX + elementStartWidth;
            anchorY = elementStartY;
          } else if (activeHandle === 'tr') {
            anchorX = elementStartX;
            anchorY = elementStartY + elementStartHeight;
          } else { // tl
            anchorX = elementStartX + elementStartWidth;
            anchorY = elementStartY + elementStartHeight;
          }
          
          // Ensure anchor point is within bounds
          anchorX = Math.max(bounds.left, Math.min(bounds.left + bounds.width, anchorX));
          anchorY = Math.max(bounds.top, Math.min(bounds.top + bounds.height, anchorY));
          
          // Binary search for maximum font size that fits
          var minFont = 10;
          var maxFont = newFontSize;
          var bestFont = minFont;
          
for (var i = 0; i < 15; i++) {
  var testFont = (minFont + maxFont) / 2;
  var dimsTest = measureText(targetText.text, testFont, targetText.font);

  var testX, testY;
  if (activeHandle === 'br') {
    testX = anchorX; testY = anchorY;
  } else if (activeHandle === 'bl') {
    testX = anchorX - dimsTest.width; testY = anchorY;
  } else if (activeHandle === 'tr') {
    testX = anchorX; testY = anchorY - dimsTest.height;
  } else { // tl
    testX = anchorX - dimsTest.width; testY = anchorY - dimsTest.height;
  }

  var fitsHorizontally = testX >= bounds.left && (testX + dimsTest.width) <= (bounds.left + bounds.width);
  var fitsVertically   = testY >= bounds.top  && (testY + dimsTest.height) <= (bounds.top + bounds.height);

  if (fitsHorizontally && fitsVertically) {
    bestFont = testFont;
    minFont = testFont;
  } else {
    maxFont = testFont;
  }
}

// Apply best size
newFontSize = bestFont;
var finalDims = measureText(targetText.text, newFontSize, targetText.font);

var newX, newY;
if (activeHandle === 'br') {
  newX = anchorX; newY = anchorY;
} else if (activeHandle === 'bl') {
  newX = anchorX - finalDims.width; newY = anchorY;
} else if (activeHandle === 'tr') {
  newX = anchorX; newY = anchorY - finalDims.height;
} else { // tl
  newX = anchorX - finalDims.width; newY = anchorY - finalDims.height;
}

targetText.fontSize = newFontSize;
targetText.width = finalDims.width;
targetText.height = finalDims.height;
targetText.x = newX;
targetText.y = newY;

clampElementPosition(targetText);
updateHiddenFields();
renderCanvas();
        } else {
          // Resize logo - maintain aspect ratio
          var aspectRatio = elementStartWidth / elementStartHeight;
          var avgDelta = (dx + dy) / 2;
          var newWidth, newHeight;
          
          // Calculate new dimensions based on handle
          if (activeHandle === 'br') {
            // Use average of dx and dy for diagonal resize
            newWidth = elementStartWidth + avgDelta;
          } else if (activeHandle === 'bl') {
            newWidth = elementStartWidth - dx;
          } else if (activeHandle === 'tr') {
            newWidth = elementStartWidth + dx;
          } else if (activeHandle === 'tl') {
            newWidth = elementStartWidth - avgDelta;
          }
          
          // Maintain aspect ratio
          newHeight = newWidth / aspectRatio;
          
          // Calculate anchor point and available space based on handle
          var anchorX, anchorY, maxWidth, maxHeight;
          if (activeHandle === 'br') {
            anchorX = elementStartX;
            anchorY = elementStartY;
            maxWidth = bounds.left + bounds.width - anchorX;
            maxHeight = bounds.top + bounds.height - anchorY;
          } else if (activeHandle === 'bl') {
            anchorX = elementStartX + elementStartWidth;
            anchorY = elementStartY;
            maxWidth = anchorX - bounds.left;
            maxHeight = bounds.top + bounds.height - anchorY;
          } else if (activeHandle === 'tr') {
            anchorX = elementStartX;
            anchorY = elementStartY + elementStartHeight;
            maxWidth = bounds.left + bounds.width - anchorX;
            maxHeight = anchorY - bounds.top;
          } else { // tl
            anchorX = elementStartX + elementStartWidth;
            anchorY = elementStartY + elementStartHeight;
            maxWidth = anchorX - bounds.left;
            maxHeight = anchorY - bounds.top;
          }
          
          // Set minimum size
          var minSize = 30;
          if (newWidth < minSize) {
            newWidth = minSize;
            newHeight = minSize / aspectRatio;
          }
          if (newHeight < minSize) {
            newHeight = minSize;
            newWidth = minSize * aspectRatio;
          }
          
          // Clamp to available space while maintaining aspect ratio
          if (newWidth > maxWidth || newHeight > maxHeight) {
            var widthScale = maxWidth / newWidth;
            var heightScale = maxHeight / newHeight;
            var scale = Math.min(widthScale, heightScale);
            newWidth = newWidth * scale;
            newHeight = newHeight * scale;
          }
          
          // Calculate position from anchor
          var newX, newY;
          if (activeHandle === 'br') {
            newX = anchorX;
            newY = anchorY;
          } else if (activeHandle === 'bl') {
            newX = anchorX - newWidth;
            newY = anchorY;
          } else if (activeHandle === 'tr') {
            newX = anchorX;
            newY = anchorY - newHeight;
          } else { // tl
            newX = anchorX - newWidth;
            newY = anchorY - newHeight;
          }
          
          logoElement.width = newWidth;
          logoElement.height = newHeight;
          logoElement.x = newX;
          logoElement.y = newY;
          
          // Ensure within bounds
          clampElementPosition(logoElement);
          
          updateHiddenFields();
          renderCanvas();
        }
      } else if (isDragging) {
        // Drag element
        var dx = coords.x - dragStartX;
        var dy = coords.y - dragStartY;
        
        var newX = elementStartX + dx;
        var newY = elementStartY + dy;
        
        // Check if new position would be within bounds
        var wouldFitHorizontally = newX >= bounds.left && (newX + elem.width) <= (bounds.left + bounds.width);
        var wouldFitVertically = newY >= bounds.top && (newY + elem.height) <= (bounds.top + bounds.height);
        
        // Only update position if it stays within bounds
        // If it would go outside in one direction, clamp that direction but allow the other
        if (wouldFitHorizontally) {
          elem.x = newX;
        } else {
          // Clamp to nearest boundary
          if (newX < bounds.left) {
            elem.x = bounds.left;
          } else if (newX + elem.width > bounds.left + bounds.width) {
            elem.x = bounds.left + bounds.width - elem.width;
          }
        }
        
        if (wouldFitVertically) {
          elem.y = newY;
        } else {
          // Clamp to nearest boundary
          if (newY < bounds.top) {
            elem.y = bounds.top;
          } else if (newY + elem.height > bounds.top + bounds.height) {
            elem.y = bounds.top + bounds.height - elem.height;
          }
        }
        
        updateHiddenFields();
        renderCanvas();
      }
    }

    function onCanvasMouseUp(e) {
      if (isDragging || isResizing) {
        generatePreviewImage();
      }
      isDragging = false;
      isResizing = false;
      activeHandle = null;
      previewCanvas.style.cursor = 'default';
    }
    
    function onCanvasTouchCancel(e) {
      // Reset all interaction states if touch is cancelled
      isDragging = false;
      isResizing = false;
      activeHandle = null;
      previewCanvas.style.cursor = 'default';
    }

    // Attach canvas event listeners
    if (previewCanvas) {
      previewCanvas.addEventListener('mousedown', onCanvasMouseDown);
      previewCanvas.addEventListener('mousemove', onCanvasMouseMove);
      previewCanvas.addEventListener('mouseup', onCanvasMouseUp);
      previewCanvas.addEventListener('touchstart', onCanvasMouseDown, { passive: false });
      previewCanvas.addEventListener('touchmove', onCanvasMouseMove, { passive: false });
      previewCanvas.addEventListener('touchend', onCanvasMouseUp);
      previewCanvas.addEventListener('touchcancel', onCanvasTouchCancel);
    }

    // Initialize text element position
    function initializeTextPosition() {
      if (!textUserMoved && placeTextInZone()) return;
      var bounds = getBoardBounds();
      textElement.x = bounds.left + bounds.width * 0.02;
      textElement.y = bounds.top + bounds.height * 0.02;
      textElement.fontSize = 55;
      
      if (textElement.text) {
        var dims = measureText(textElement.text, textElement.fontSize, textElement.font);
        textElement.width = dims.width;
        textElement.height = dims.height;
      }
      
      updateHiddenFields();
    }
    function initializeTextPosition2() {
  var bounds = getBoardBounds();

  // Put second message lower than first one
  textElement2.x = bounds.left + bounds.width * 0.02;
  textElement2.y = bounds.top + bounds.height * 0.12; // <-- adjust if you want lower/higher
  textElement2.fontSize = 55;
  textElement2.font = textElement.font; // same font as selected

  if (textElement2.text) {
    var dims2 = measureText(textElement2.text, textElement2.fontSize, textElement2.font);
    textElement2.width = dims2.width;
    textElement2.height = dims2.height;
  }
}
    // Initialize logo position
    function initializeLogoPosition() {
      var bounds = getBoardBounds();
      var centerX = bounds.left + bounds.width / 2;
      var centerY = bounds.top + bounds.height / 2;
      
      // Use actual image dimensions if logo image is loaded
      if (logoImage) {
        var imgWidth = logoImage.naturalWidth || logoImage.width;
        var imgHeight = logoImage.naturalHeight || logoImage.height;
        var aspectRatio = imgWidth / imgHeight;
        
        // Set initial size to be 30% of board width (reasonable starting size)
        var targetWidth = bounds.width * 0.3;
        logoElement.width = targetWidth;
        logoElement.height = targetWidth / aspectRatio;
        
        // If height is too large, scale based on height instead
        var maxHeight = bounds.height * 0.3;
        if (logoElement.height > maxHeight) {
          logoElement.height = maxHeight;
          logoElement.width = maxHeight * aspectRatio;
        }
        
        // Ensure minimum size
        if (logoElement.width < 50) {
          logoElement.width = 50;
          logoElement.height = 50 / aspectRatio;
        }
      } else {
        // Fallback if no image loaded yet
        logoElement.width = 100;
        logoElement.height = 100;
      }
      
      logoElement.x = centerX - logoElement.width / 2;
      logoElement.y = centerY - logoElement.height / 2;
      
      updateHiddenFields();
    }

    // Load base image
    function loadBaseImage(src) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function() {
        baseImage = img;
        currentBaseSrc = src;
        
        // Use higher resolution for crisp rendering
        // Set a good base resolution (minimum 1000px for quality)
        var targetWidth = Math.max(1000, img.naturalWidth || 1000);
        var aspectRatio = (img.naturalHeight || 1000) / (img.naturalWidth || 1000);
        var targetHeight = targetWidth * aspectRatio;
        
        previewCanvas.width = targetWidth;
        previewCanvas.height = targetHeight;
        
        if (textElement.text && !textElement.visible) {
          textElement.visible = true;
          initializeTextPosition();
        } else if (currentLayout && textElement.visible && textElement.text) {
          textUserMoved = false;
          placeTextInZone();
        }
        if (currentLayout) {
          updateSecondInputVisibility();
          text2UserMoved = false;
          if (textElement2.visible && textElement2.text) placeText2InZone();
        }
        
        if (logoElement.enabled && !logoElement.visible && logoImage) {
          logoElement.visible = true;
          initializeLogoPosition();
        }
        
        renderCanvas();
      };
      img.src = src;
    }

    // Text input handling
    textInput.addEventListener('input', function() {
      var value = this.value;
      if (value.length > MAX_TOTAL_CHARS) {
        value = value.substring(0, MAX_TOTAL_CHARS);
        this.value = value;
      }
      var remaining = MAX_TOTAL_CHARS - value.length;
      charCount.textContent = remaining + ' character(s) left';

      textElement.text = value;
      if (hiddenText) hiddenText.value = value;
      
      if (value) {
        var dims = measureText(value, textElement.fontSize, textElement.font);
        textElement.width = dims.width;
        textElement.height = dims.height;
        
        if (!textElement.visible) {
          textElement.visible = true;
          initializeTextPosition();
        }
      
        
        // Auto-fit text to board if it overflows
        autoFitTextToBoard();
        
        selectedElement = 'text';
      } else {
        textElement.visible = false;
        textUserMoved = false;
        selectedElement = null;
      }
      
      renderCanvas();
      setTimeout(generatePreviewImage, 100);
    });

// SECOND text input handling
if (textInput2) {
  textInput2.addEventListener('input', function() {
    var value2 = this.value || '';
 if (value2.length > MAX_SECOND_TEXT_CHARS) {
  value2 = value2.substring(0, MAX_SECOND_TEXT_CHARS);
  this.value = value2;
}

if (charCount2) {
  charCount2.textContent = 
    (MAX_SECOND_TEXT_CHARS - value2.length) + ' character(s) left';
}

    textElement2.text = value2;
    textElement2.font = textElement.font; // keep same font
    textElement2.fontSize = textElement.fontSize; // keep same size (optional)

    if (hiddenText2) hiddenText2.value = value2;

    if (value2) {
      var dims2 = measureText(value2, textElement2.fontSize, textElement2.font);
      textElement2.width = dims2.width;
      textElement2.height = dims2.height;

     if (!textElement2.visible) {
  textElement2.visible = true;
}
snapSecondTextToBottom();

      selectedElement = 'text2';
    } else {
      textElement2.visible = false;
      if (selectedElement === 'text2') selectedElement = null;
    }

    renderCanvas();
    setTimeout(generatePreviewImage, 100);
  });
}

    // Font selection
    function selectFont(fontName, imgSrc) {
      fontSelect.value = fontName;
      if (fontSelectedImg && imgSrc) {
        fontSelectedImg.src = imgSrc;
        fontSelectedImg.alt = fontName;
      }
      
      textElement.font = fontName;
      if (hiddenFont) hiddenFont.value = fontName;
      snapSecondTextToBottom();
      
      // Load the font before rendering
      if (document.fonts && document.fonts.load) {
        document.fonts.load(textElement.fontSize + 'px "' + fontName + '"').then(function() {
          if (textElement.visible && textElement.text) {
            autoFitTextToBoard();
            var dims = measureText(textElement.text, textElement.fontSize, textElement.font);
            textElement.width = dims.width;
            textElement.height = dims.height;
            clampElementPosition(textElement);
          }
          
          renderCanvas();
          generatePreviewImage();
        }).catch(function() {
          // Font loading failed, render anyway
          if (textElement.visible && textElement.text) {
            autoFitTextToBoard();
            var dims = measureText(textElement.text, textElement.fontSize, textElement.font);
            textElement.width = dims.width;
            textElement.height = dims.height;
            clampElementPosition(textElement);
          }
          
          renderCanvas();
          generatePreviewImage();
        });
      } else {
        // Fallback for browsers without Font Loading API
        if (textElement.visible && textElement.text) {
          autoFitTextToBoard();
          var dims = measureText(textElement.text, textElement.fontSize, textElement.font);
          textElement.width = dims.width;
          textElement.height = dims.height;
          clampElementPosition(textElement);
        }
        
        renderCanvas();
        generatePreviewImage();
      }
      
      fontOptions.querySelectorAll('.product-customizer__font-option').forEach(function(opt) {
        opt.classList.toggle('is-selected', opt.dataset.value === fontName);
      });
    }

    // Font dropdown handling
    if (fontSelectedBtn) {
      fontSelectedBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = fontDropdown.classList.contains('is-open');
        fontDropdown.classList.toggle('is-open', !isOpen);
        fontSelectedBtn.setAttribute('aria-expanded', !isOpen);
      });
    }

    if (fontOptions) {
      fontOptions.addEventListener('click', function(e) {
        var option = e.target.closest('.product-customizer__font-option');
        if (option) {
          selectFont(option.dataset.value, option.dataset.img);
          fontDropdown.classList.remove('is-open');
          fontSelectedBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    document.addEventListener('click', function(e) {
      if (fontDropdown && !fontDropdown.contains(e.target)) {
        fontDropdown.classList.remove('is-open');
        if (fontSelectedBtn) fontSelectedBtn.setAttribute('aria-expanded', 'false');
      }
    });

    // Logo toggle handler
    if (logoToggle && logoUploadSection) {
      logoToggle.addEventListener('change', function() {
        logoElement.enabled = this.checked;
        logoUploadSection.style.display = logoElement.enabled ? 'block' : 'none';
        
        if (!logoElement.enabled) {
          logoElement.visible = false;
          isLogoSizeValid = true; // Reset validation when logo is disabled
          if (hiddenLogoEnabled) hiddenLogoEnabled.value = '';
          if (hiddenLogoData) hiddenLogoData.value = '';
          if (hiddenLogoUrl) hiddenLogoUrl.value = '';
          if (hiddenLogoPrice) hiddenLogoPrice.value = '';
        } else {
          // Logo enabled - if image exists, make it visible
          if (logoImage) {
            logoElement.visible = true;
            if (!logoElement.x && !logoElement.y) {
              initializeLogoPosition();
            }
          }
          // Always set these when enabled
          if (hiddenLogoEnabled) hiddenLogoEnabled.value = 'Yes';
          if (hiddenLogoPrice && logoSection) {
            var price = logoSection.getAttribute('data-logo-price');
            hiddenLogoPrice.value = price || '0';
          }
        }
        
        renderCanvas();
        generatePreviewImage();
      });
    }

    // Logo file upload handler
    if (logoFileInput) {
      var fileLabel = container.querySelector('.product-customizer__file-label');
      if (fileLabel) {
        fileLabel.addEventListener('click', function() {
          logoFileInput.click();
        });
      }

      logoFileInput.addEventListener('change', function(e) {
        var file = e.target.files[0];
        if (!file) return;

        if (!file.type.startsWith('image/')) {
          alert('Please upload an image file.');
          isLogoSizeValid = false;
          return;
        }

        // Validate file size (max 5MB)
        var maxSize = 5 * 1024 * 1024; // 5MB in bytes
        if (file.size > maxSize) {
          alert('Logo file size must be less than 5MB. Please choose a smaller image.');
          e.target.value = ''; // Clear the file input
          isLogoSizeValid = false;
          return;
        }

        // File is valid
        isLogoSizeValid = true;
        
        var reader = new FileReader();
        reader.onload = function(event) {
          var img = new Image();
          img.onload = function() {
            logoImage = img;
            logoElement.visible = true;
            logoElement.enabled = true; // Ensure enabled when image is loaded
            
            console.log('Logo image loaded, size:', img.naturalWidth, 'x', img.naturalHeight);

            // ✅ Compress logo before saving to properties (reduces size)
            var maxLogoPx = 600; // reduce if still large
            var c = document.createElement('canvas');
            var ctx = c.getContext('2d');

            var w = img.naturalWidth;
            var h = img.naturalHeight;

            var scale = Math.min(1, maxLogoPx / Math.max(w, h));
            c.width = Math.round(w * scale);
            c.height = Math.round(h * scale);

            ctx.drawImage(img, 0, 0, c.width, c.height);

            // JPEG is much smaller than PNG base64
            var compressed = c.toDataURL('image/jpeg', 0.8);

            // ✅ Save compressed data instead of original
            if (hiddenLogoUrl) hiddenLogoUrl.value = compressed;
            if (hiddenLogoData) hiddenLogoData.value = compressed;

            if (hiddenLogoEnabled) hiddenLogoEnabled.value = 'Yes';
            if (hiddenLogoPrice && logoSection) {
              var price = logoSection.getAttribute('data-logo-price');
              hiddenLogoPrice.value = price || '0';
            }

            // Initialize position with actual image dimensions
            initializeLogoPosition();
            selectedElement = 'logo';
            
            console.log('Rendering canvas with logo...');
            renderCanvas();
            generatePreviewImage();
          };
          img.src = event.target.result;
        };
        reader.readAsDataURL(file);
      });
    }

    // Gift wrap toggle
    if (giftWrapToggle) {
      giftWrapToggle.addEventListener('change', function() {
        var isEnabled = this.checked;
        if (isEnabled) {
          if (hiddenGiftWrap) hiddenGiftWrap.value = 'Yes';
          if (hiddenGiftWrapPrice && giftWrapSection) {
            var price = giftWrapSection.getAttribute('data-gift-wrap-price');
            hiddenGiftWrapPrice.value = price || '0';
          }
        } else {
          if (hiddenGiftWrap) hiddenGiftWrap.value = '';
          if (hiddenGiftWrapPrice) hiddenGiftWrapPrice.value = '';
        }
      });
    }

    // Markers toggle
    if (markersToggle) {
      markersToggle.addEventListener('change', function() {
        var isEnabled = this.checked;
        if (isEnabled) {
          if (hiddenMarkers) hiddenMarkers.value = 'Yes';
          if (hiddenMarkersPrice && markersSection) {
            var price = markersSection.getAttribute('data-markers-price');
            hiddenMarkersPrice.value = price || '0';
          }
        } else {
          if (hiddenMarkers) hiddenMarkers.value = '';
          if (hiddenMarkersPrice) hiddenMarkersPrice.value = '';
        }
      });
    }

    // Generate preview image for cart
    function generatePreviewImage() {
      if (!hiddenPreview || !baseImage) return;
      
      try {
        // Set flag to hide UI elements (handles and borders)
        isRenderingForPreview = true;
        
        // Render canvas without selection UI
        renderCanvas();
        
        // ---- CHANGED: 300px max, PNG format ---
        var maxSize = 300; // reduced from 1500 — 6x fewer pixels
        var scale = 1;
        
        if (previewCanvas.width > maxSize) {
          scale = maxSize / previewCanvas.width;
        }
        
        var outputWidth = Math.floor(previewCanvas.width * scale);
        var outputHeight = Math.floor(previewCanvas.height * scale);
        
        var smallCanvas = document.createElement('canvas');
        smallCanvas.width = outputWidth;
        smallCanvas.height = outputHeight;
        var smallCtx = smallCanvas.getContext('2d');
        smallCtx.drawImage(previewCanvas, 0, 0, outputWidth, outputHeight);
        
        // PNG at 300px max — keeps format, reduces size via resolution
        var previewDataUrl = smallCanvas.toDataURL('image/png');
        hiddenPreview.value = previewDataUrl;
        if (hiddenPreviewUrl) hiddenPreviewUrl.value = previewDataUrl;
        // ---- END CHANGE ----

        console.log('Preview image size:', (hiddenPreview.value.length / 1024).toFixed(2) + 'KB');
        
        // Restore flag and re-render with UI elements
        isRenderingForPreview = false;
        renderCanvas();
      } catch(err) {
        console.error('Failed to generate preview image:', err);
        hiddenPreview.value = '';
        if (hiddenPreviewUrl) hiddenPreviewUrl.value = '';
        isRenderingForPreview = false; // Ensure flag is reset on error
      }
    }

    // Helper function to format price
    function formatPrice(cents) {
      if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
      var format = (window.MinimogSettings && window.MinimogSettings.money_format) || '${{amount}}';
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = precision || 2;
        thousands = thousands || ',';
        decimal = decimal || '.';
        
        if (isNaN(number) || number == null) return '0.00';
        
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var cents = parts[1] ? (decimal + parts[1]) : '';
        
        return dollars + cents;
      }
      
      var formatMatch = format.match(placeholderRegex);
      if (formatMatch) {
        switch (formatMatch[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        }
        return format.replace(placeholderRegex, value);
      }
      
      return formatWithDelimiters(cents, 2);
    }

    // Variant swatches data
    function loadVariantSwatchesData() {
      var dataScript = document.getElementById('variant-swatches-data');
      if (dataScript) {
        try {
          variantSwatchesData = JSON.parse(dataScript.textContent);
        } catch (e) {
          console.error('Failed to parse variant swatches data:', e);
        }
      }
    }
    loadVariantSwatchesData();

    // Setup swatches for current variant
    function setupSwatches(variantId) {
      if (!swatchContainer) return;
      
      var swatchData = variantSwatchesData[variantId];
      if (!swatchData || !swatchData.swatches || swatchData.swatches.length === 0) {
        swatchContainer.innerHTML = '';
        return;
      }

      swatchContainer.setAttribute('data-variant-id', variantId);
      swatchContainer.innerHTML = '';
      
      swatchData.swatches.forEach(function(swatch, index) {
        var item = document.createElement('div');
        item.className = 'product-customizer__swatch-item' + (index === 0 ? ' is-selected' : '');
        item.setAttribute('data-image-url', swatch.full);
        
        var img = document.createElement('img');
        img.src = swatch.thumb;
        img.alt = swatch.alt || 'Style option ' + (index + 1);
        img.loading = 'lazy';
        
        item.appendChild(img);
        swatchContainer.appendChild(item);
      });
      
      attachSwatchHandlers();
      
      // Load first swatch
      if (swatchData.swatches[0] && previewImage) {
        loadBaseImage(swatchData.swatches[0].full);
        
        if (hiddenImage) {
          hiddenImage.value = swatchData.swatches[0].alt || swatchData.swatches[0].full.split('/').pop().split('?')[0];
        }
        if (hiddenImageUrl) {
          hiddenImageUrl.value = swatchData.swatches[0].full;
        }
        
        if (swatchLabel) {
          var selectedName = swatchLabel.querySelector('.product-customizer__swatch-selected');
          if (!selectedName) {
            selectedName = document.createElement('span');
            selectedName.className = 'product-customizer__swatch-selected';
            swatchLabel.appendChild(document.createTextNode(': '));
            swatchLabel.appendChild(selectedName);
          }
          selectedName.textContent = swatchData.swatches[0].alt || 'Style option 1';
        }
      }
    }
    
    // Attach click handlers to swatch items
    function attachSwatchHandlers() {
      if (!swatchContainer) return;
      
      var swatchItems = swatchContainer.querySelectorAll('.product-customizer__swatch-item');
      
      swatchItems.forEach(function(item, index) {
        item.addEventListener('click', function() {
          swatchContainer.querySelectorAll('.product-customizer__swatch-item').forEach(function(el) {
            el.classList.remove('is-selected');
          });
          
          item.classList.add('is-selected');
          
          var imageUrl = item.getAttribute('data-image-url');
          var imgElement = item.querySelector('img');
          
          if (imageUrl) {
            loadBaseImage(imageUrl);
          }
          
          if (hiddenImage && imgElement) {
            hiddenImage.value = imgElement.alt || imageUrl.split('/').pop().split('?')[0];
          }
          
          if (hiddenImageUrl && imageUrl) {
            hiddenImageUrl.value = imageUrl;
          }
          
          if (swatchLabel && imgElement) {
            var selectedName = swatchLabel.querySelector('.product-customizer__swatch-selected');
            if (!selectedName) {
              selectedName = document.createElement('span');
              selectedName.className = 'product-customizer__swatch-selected';
              swatchLabel.appendChild(selectedName);
            }
            selectedName.textContent = imgElement.alt || 'Style ' + (index + 1);
          }
        });
      });
    }

    // Show/hide customizer based on variant selection
    function checkVariant() {
      var variantPicker = document.querySelector('variant-picker');
      if (!variantPicker) return;

      var selectedOptions = [];
      variantPicker.querySelectorAll('input[type="radio"]:checked').forEach(function(input) {
        selectedOptions.push(input.value);
      });
      variantPicker.querySelectorAll('select').forEach(function(select) {
        if (select.value) selectedOptions.push(select.value);
      });

      var isCustomize = selectedOptions.some(function(opt) {
        return opt.toLowerCase() === CUSTOMIZE_VARIANT_NAME.toLowerCase();
      });

      if (isCustomize) {
        isCustomizeActive = true;
        container.classList.add('is-visible');
        
        if (hiddenText) hiddenText.disabled = false;
        if (hiddenFont) hiddenFont.disabled = false;
        if (hiddenFontSize) hiddenFontSize.disabled = false;
        if (hiddenPosition) hiddenPosition.disabled = false;
        if (hiddenImage) hiddenImage.disabled = false;
        if (hiddenPreview) hiddenPreview.disabled = false;
        if (hiddenImageUrl) hiddenImageUrl.disabled = false;
        if (hiddenLogoEnabled) hiddenLogoEnabled.disabled = false;
        if (hiddenLogoData) hiddenLogoData.disabled = false;
        if (hiddenLogoPosition) hiddenLogoPosition.disabled = false;
        if (hiddenLogoSize) hiddenLogoSize.disabled = false;
        if (hiddenLogoPrice) hiddenLogoPrice.disabled = false;
        if (hiddenGiftWrap) hiddenGiftWrap.disabled = false;
        if (hiddenGiftWrapPrice) hiddenGiftWrapPrice.disabled = false;
        if (hiddenMarkers) hiddenMarkers.disabled = false;
        if (hiddenMarkersPrice) hiddenMarkersPrice.disabled = false;
       if (hiddenText2) {
  hiddenText2.disabled = false; // enable when customizer active
}

        updateCurrentVariant();
      } else {
        isCustomizeActive = false;
        container.classList.remove('is-visible');
        
        // Clear and disable all customization fields
        if (hiddenText) { hiddenText.value = ''; hiddenText.disabled = true; }
        if (hiddenFont) { hiddenFont.value = ''; hiddenFont.disabled = true; }
        if (hiddenFontSize) { hiddenFontSize.value = ''; hiddenFontSize.disabled = true; }
        if (hiddenPosition) { hiddenPosition.value = ''; hiddenPosition.disabled = true; }
        if (hiddenImage) { hiddenImage.value = ''; hiddenImage.disabled = true; }
        if (hiddenPreview) { hiddenPreview.value = ''; hiddenPreview.disabled = true; }
        if (hiddenImageUrl) { hiddenImageUrl.value = ''; hiddenImageUrl.disabled = true; }
        if (hiddenLogoEnabled) { hiddenLogoEnabled.value = ''; hiddenLogoEnabled.disabled = true; }
        if (hiddenLogoData) { hiddenLogoData.value = ''; hiddenLogoData.disabled = true; }
        if (hiddenLogoPosition) { hiddenLogoPosition.value = ''; hiddenLogoPosition.disabled = true; }
        if (hiddenLogoSize) { hiddenLogoSize.value = ''; hiddenLogoSize.disabled = true; }
        if (hiddenLogoPrice) { hiddenLogoPrice.value = ''; hiddenLogoPrice.disabled = true; }
        if (hiddenGiftWrap) { hiddenGiftWrap.value = ''; hiddenGiftWrap.disabled = true; }
        if (hiddenGiftWrapPrice) { hiddenGiftWrapPrice.value = ''; hiddenGiftWrapPrice.disabled = true; }
        if (hiddenMarkers) { hiddenMarkers.value = ''; hiddenMarkers.disabled = true; }
        if (hiddenMarkersPrice) { hiddenMarkersPrice.value = ''; hiddenMarkersPrice.disabled = true; }
      }
    }
    
    // Update current variant
    function updateCurrentVariant() {
      var urlParams = new URLSearchParams(window.location.search);
      var variantId = urlParams.get('variant');
      
      if (!variantId) {
        var variantInput = document.querySelector('input[name="id"]');
        if (variantInput && variantInput.value) {
          variantId = variantInput.value;
        }
      }
      
      if (variantId && variantSwatchesData[variantId]) {
        var variantData = variantSwatchesData[variantId];
        
        // Update logo section
        if (logoSection) {
          if (variantData.logoEnabled) {
            logoSection.classList.add('is-visible');
            logoSection.style.display = 'block';
            logoSection.setAttribute('data-logo-price', variantData.logoPrice || '0');
            
            var priceInfo = logoSection.querySelector('.product-customizer__price-info');
            if (priceInfo) {
              if (variantData.logoPrice > 0) {
                priceInfo.textContent = 'Elevate your design with a custom logo engraving for an additional ' + formatPrice(variantData.logoPrice) + '.';
                priceInfo.style.display = '';
              } else {
                priceInfo.style.display = 'none';
              }
            }
          } else {
            logoSection.classList.remove('is-visible');
            logoSection.style.display = 'none';
            logoElement.enabled = false;
            logoElement.visible = false;
            if (logoToggle) logoToggle.checked = false;
            if (logoUploadSection) logoUploadSection.style.display = 'none';
            if (hiddenLogoPrice) hiddenLogoPrice.value = '';
          }
        }
        
        // Update gift wrap section
        if (giftWrapSection) {
          if (variantData.giftWrapEnabled) {
            giftWrapSection.classList.add('is-visible');
            giftWrapSection.style.display = 'block';
            giftWrapSection.setAttribute('data-gift-wrap-price', variantData.giftWrapPrice || '0');
            
            var priceInfo = giftWrapSection.querySelector('.product-customizer__price-info');
            if (priceInfo) {
              if (variantData.giftWrapPrice > 0) {
                priceInfo.textContent = 'Additional charges of ' + formatPrice(variantData.giftWrapPrice) + ' applicable';
                priceInfo.style.display = '';
              } else {
                priceInfo.style.display = 'none';
              }
            }
          } else {
            giftWrapSection.classList.remove('is-visible');
            giftWrapSection.style.display = 'none';
            if (giftWrapToggle) giftWrapToggle.checked = false;
            if (hiddenGiftWrap) hiddenGiftWrap.value = '';
            if (hiddenGiftWrapPrice) hiddenGiftWrapPrice.value = '';
          }
        }
        
        // Update markers section
        if (markersSection) {
          if (variantData.markersEnabled) {
            markersSection.classList.add('is-visible');
            markersSection.style.display = 'block';
            markersSection.setAttribute('data-markers-price', variantData.markersPrice || '0');
            
            var priceInfo = markersSection.querySelector('.product-customizer__price-info');
            if (priceInfo) {
              if (variantData.markersPrice > 0) {
                priceInfo.textContent = 'Add 1 White & 1 Red marker set for an additional ' + formatPrice(variantData.markersPrice) + '.';
                priceInfo.style.display = '';
              } else {
                priceInfo.style.display = 'none';
              }
            }
          } else {
            markersSection.classList.remove('is-visible');
            markersSection.style.display = 'none';
            if (markersToggle) markersToggle.checked = false;
            if (hiddenMarkers) hiddenMarkers.value = '';
            if (hiddenMarkersPrice) hiddenMarkersPrice.value = '';
          }
        }
        
        setupSwatches(variantId);
      } else {
        var firstVariantId = Object.keys(variantSwatchesData)[0];
        if (firstVariantId) {
          updateCurrentVariant();
        }
      }
    }

    // Listen for variant changes
    function setupVariantListener() {
      var variantPicker = document.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('change', function() {
          setTimeout(checkVariant, 100);
        });
        return true;
      }
      return false;
    }

    setupVariantListener();

    // Initial checks
    checkVariant();
    setTimeout(checkVariant, 300);
    setTimeout(checkVariant, 800);
    setTimeout(function() {
      setupVariantListener();
      checkVariant();
    }, 1500);
    setTimeout(checkVariant, 3000);

    window.addEventListener('popstate', function() {
      setTimeout(checkVariant, 200);
    });

    // Fee product variant IDs
    var FEE_PRODUCT_IDS = {
      logo: '47614448795893',
      giftWrap: '47614450401525',
      markers: '47614450794741'
    };

    // Store original fetch
    var originalFetch = window.fetch;
    var isAddingFees = false;
    var isBuyItNowMode = false;

    // Override fetch to intercept cart additions
    window.fetch = function() {
      var url = arguments[0];
      var options = arguments[1] || {};
      
      // Check if this is a cart add request from our customizer
      // Only intercept if: 1) customizer exists, 2) is active, 3) is visible
      var customizerEl = document.querySelector('.product-customizer');
      var customizerIsVisible = customizerEl && customizerEl.classList.contains('is-visible');
      
      if (typeof url === 'string' && url.includes('/cart/add') && !isAddingFees && customizerIsVisible && isCustomizeActive) {
        // Validate logo size before allowing cart add
        if (logoElement.enabled && !isLogoSizeValid) {
          alert('Cannot add to cart: Logo file size exceeds 5MB. Please upload a smaller image.');
          // Return a rejected promise to prevent cart add
          return Promise.reject(new Error('Logo file size exceeds limit'));
        }
        
        // Extract quantity from request body before sending
        var requestedQuantity = 1;
        try {
          if (options.body) {
            if (options.body instanceof FormData) {
              requestedQuantity = parseInt(options.body.get('quantity')) || 1;
            } else if (typeof options.body === 'string') {
              var bodyData = JSON.parse(options.body);
              requestedQuantity = parseInt(bodyData.quantity) || 1;
            }
          }
        } catch (e) {
          console.log('Could not parse quantity from request, using 1');
        }
        console.log('Requested quantity from add-to-cart:', requestedQuantity);
        
        // Call original fetch
        return originalFetch.apply(this, arguments).then(function(response) {
          // Only process if response is ok and customizer still exists
          if (response.ok && document.querySelector('.product-customizer')) {
            // Clone response so we can read it
            var clonedResponse = response.clone();
            
            clonedResponse.json().then(function(data) {
              // Check if cart add was successful (no error)
              if (!data.status && !data.message && data.id && isCustomizeActive) {
                console.log('Cart add successful, checking for fees...');
                
                // Use the quantity from the REQUEST, not the response
                // Response data.quantity is the TOTAL quantity in cart after combining
                // Request quantity is the ACTUAL amount being added
                var productQuantity = requestedQuantity;
                console.log('Product quantity to add fees for:', productQuantity);
                
                // Get which fees are enabled
                var feesToAdd = [];
              
              if (logoElement.enabled && hiddenLogoEnabled && hiddenLogoEnabled.value === 'Yes' && hiddenLogoPrice) {
                var logoPrice = parseInt(hiddenLogoPrice.value) || 0;
                console.log('Logo price:', logoPrice);
                if (logoPrice > 0) {
                  feesToAdd.push({ id: FEE_PRODUCT_IDS.logo, quantity: productQuantity, type: 'logo' });
                }
              }
              
              if (hiddenGiftWrap && hiddenGiftWrap.value === 'Yes' && hiddenGiftWrapPrice) {
                var giftPrice = parseInt(hiddenGiftWrapPrice.value) || 0;
                console.log('Gift wrap price:', giftPrice);
                if (giftPrice > 0) {
                  feesToAdd.push({ id: FEE_PRODUCT_IDS.giftWrap, quantity: productQuantity, type: 'gift_wrap' });
                }
              }
              
              if (hiddenMarkers && hiddenMarkers.value === 'Yes' && hiddenMarkersPrice) {
                var markersPrice = parseInt(hiddenMarkersPrice.value) || 0;
                console.log('Markers price:', markersPrice);
                if (markersPrice > 0) {
                  feesToAdd.push({ id: FEE_PRODUCT_IDS.markers, quantity: productQuantity, type: 'markers' });
                }
              }

              console.log('Fees to add:', feesToAdd);
              
              // Add fee products (start after a brief delay)
              if (feesToAdd.length > 0) {
                // Show skeleton loader on subtotal
                var subtotalElement = document.querySelector('[data-cart-subtotal]');
                if (subtotalElement) {
                  subtotalElement.classList.add('m-cart__subtotal--loading');
                }
                
                // Disable checkout button and show loader
                var checkoutBtn = document.querySelector('[data-cart-checkout-btn]');
                if (checkoutBtn) {
                  checkoutBtn.disabled = true;
                  checkoutBtn.classList.add('m-checkout-btn--loading');
                }
                
                // Disable view cart link
                var viewCartLink = document.querySelector('[data-cart-view-cart-link]');
                if (viewCartLink) {
                  viewCartLink.classList.add('disabled');
                }
                
                setTimeout(function() {
                  addFeeProducts(feesToAdd, 0);
                }, 300);
              }
            }
          }).catch(function(err) {
            console.error('Error parsing cart response:', err);
          });
          }
          
          return response;
        });
      }
      
      // For all other requests, use original fetch
      return originalFetch.apply(this, arguments);
    };

    // Function to refresh cart drawer with fresh data
    function refreshCartDrawer() {
      console.log('Refreshing cart drawer...');
      originalFetch('/cart.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          console.log('Fresh cart fetched - Total:', cart.total_price);
          
          // Update subtotal display in cart drawer
          var subtotalPrice = document.querySelector('[data-cart-subtotal-price]');
          if (subtotalPrice) {
            var formattedPrice = window.Shopify && window.Shopify.formatMoney 
              ? window.Shopify.formatMoney(cart.total_price, window.theme && window.theme.moneyFormat || '${{amount}}')
              : 'Rs. ' + (cart.total_price / 100).toFixed(2);
            subtotalPrice.textContent = formattedPrice;
            console.log('✅ Updated subtotal to:', formattedPrice);
          }
          
          // Trigger cart update event for other components
          if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
            window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { source: 'fee-refresh' });
          }
        })
        .catch(function(err) {
          console.error('Error refreshing cart drawer:', err);
        });
    }

    // Function to add fee products sequentially
    function addFeeProducts(fees, index) {
      if (index >= fees.length) {
        isAddingFees = false;
        
        // If in Buy It Now mode, redirect to checkout
        if (isBuyItNowMode) {
          console.log('Buy It Now mode: Redirecting to checkout...');
          isBuyItNowMode = false;
          
          // Reset all toggles before leaving to checkout
          var customizerContainer = document.querySelector('.product-customizer');
          if (customizerContainer) {
            var logoToggle = customizerContainer.querySelector('.product-customizer__toggle-input');
            var giftWrapToggle = customizerContainer.querySelector('.product-customizer__gift-wrap-toggle');
            var markersToggle = customizerContainer.querySelector('.product-customizer__markers-toggle');
            var logoUploadSection = customizerContainer.querySelector('.product-customizer__logo-upload');
            
            if (logoToggle) {
              logoToggle.checked = false;
              if (logoUploadSection) logoUploadSection.style.display = 'none';
            }
            if (giftWrapToggle) giftWrapToggle.checked = false;
            if (markersToggle) markersToggle.checked = false;
          }
          
          window.location.href = '/checkout';
          return;
        }
        
        // Otherwise, update cart drawer for normal Add to Cart
        setTimeout(function() {
          fetch(window.MinimogSettings.routes.cart + '?section_id=cart-drawer')
            .then(function(response) { return response.text(); })
            .then(function(responseText) {
              var html = new DOMParser().parseFromString(responseText, 'text/html');
              
              // Update cart items
              var newCartItems = html.querySelector('[data-minimog-cart-items]');
              var currentCartItems = document.querySelector('[data-minimog-cart-items]');
              if (newCartItems && currentCartItems) {
                currentCartItems.innerHTML = newCartItems.innerHTML;
              }
              
              // Update discounts
              var newDiscounts = html.querySelector('[data-minimog-cart-discounts]');
              var currentDiscounts = document.querySelector('[data-minimog-cart-discounts]');
              if (newDiscounts && currentDiscounts) {
                currentDiscounts.innerHTML = newDiscounts.innerHTML;
              }
              
              // Update subtotal
              var newSubtotal = html.querySelector('[data-cart-subtotal]');
              var currentSubtotal = document.querySelector('[data-cart-subtotal]');
              if (newSubtotal && currentSubtotal) {
                currentSubtotal.innerHTML = newSubtotal.innerHTML;
                // Remove loading class
                currentSubtotal.classList.remove('m-cart__subtotal--loading');
              }
              
              // Re-enable checkout button and hide loader
              var checkoutBtn = document.querySelector('[data-cart-checkout-btn]');
              if (checkoutBtn) {
                checkoutBtn.disabled = false;
                checkoutBtn.classList.remove('m-checkout-btn--loading');
              }
              
              // Re-enable view cart link
              var viewCartLink = document.querySelector('[data-cart-view-cart-link]');
              if (viewCartLink) {
                viewCartLink.classList.remove('disabled');
              }
            })
            .catch(function(err) {
              console.error('Error refreshing cart drawer:', err);
            });
        }, 300);
        return;
      }

      isAddingFees = true;
      var fee = fees[index];
      console.log('Adding fee product:', fee);
      console.log('Full variant ID:', fee.id, 'Type:', typeof fee.id);
      
      var formData = new FormData();
      formData.append('id', fee.id);
      formData.append('quantity', fee.quantity);
      formData.append('properties[_Customization Fee]', fee.type);

      var config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      var cartAddUrl = window.MinimogSettings && window.MinimogSettings.routes 
        ? window.MinimogSettings.routes.cart_add_url 
        : '/cart/add.js';

      originalFetch(cartAddUrl, config)
        .then(function(response) {
          if (!response.ok) {
            console.error('Cart add failed with status:', response.status, response.statusText);
          }
          return response.json();
        })
        .then(function(data) {
          console.log('Full Shopify response:', JSON.stringify(data, null, 2));
          
          if (data.status || data.message || data.description || !data.id) {
            console.error('❌ Fee product add FAILED:', {
              type: fee.type,
              variant_id: fee.id,
              status: data.status,
              message: data.message,
              description: data.description,
              full_response: data
            });
          } else {
            console.log('✅ Fee product added successfully:', fee.type, '-', data.product_title, '(Qty:', data.quantity + ')');
          }
          // Add next fee
          addFeeProducts(fees, index + 1);
        })
        .catch(function(error) {
          console.error('Error adding fee product:', error);
          // Continue with next fee even if one fails
          addFeeProducts(fees, index + 1);
        });
    }

    // Intercept Buy It Now / Payment Button clicks
    function setupBuyItNowInterceptor() {
      var productForm = container.closest('product-form');
      if (!productForm) return;
      
      var paymentButton = productForm.querySelector('.m-product-dynamic-checkout');
      if (!paymentButton) return;
      
      var addToCartButton = productForm.querySelector('[name="add"]');
      if (!addToCartButton) return;
      
      console.log('Setting up Buy It Now interceptor');
      
      // Listen for clicks on the payment button container
      paymentButton.addEventListener('click', function(e) {
        // Only intercept if customizer is active and visible
        if (!isCustomizeActive || !container.classList.contains('is-visible')) {
          return; // Let it proceed normally
        }
        
        // Validate logo size before allowing checkout
        if (logoElement.enabled && !isLogoSizeValid) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          alert('Cannot proceed to checkout: Logo file size exceeds 5MB. Please upload a smaller image.');
          return false;
        }
        
        // Check if we have any customizations that require fees
        var hasCustomizations = false;
        
        if (logoElement.enabled && hiddenLogoEnabled && hiddenLogoEnabled.value === 'Yes' && hiddenLogoPrice) {
          var logoPrice = parseInt(hiddenLogoPrice.value) || 0;
          if (logoPrice > 0) hasCustomizations = true;
        }
        
        if (hiddenGiftWrap && hiddenGiftWrap.value === 'Yes' && hiddenGiftWrapPrice) {
          var giftPrice = parseInt(hiddenGiftWrapPrice.value) || 0;
          if (giftPrice > 0) hasCustomizations = true;
        }
        
        if (hiddenMarkers && hiddenMarkers.value === 'Yes' && hiddenMarkersPrice) {
          var markersPrice = parseInt(hiddenMarkersPrice.value) || 0;
          if (markersPrice > 0) hasCustomizations = true;
        }
        
        // If there are customizations with fees, intercept and use Add to Cart flow
        if (hasCustomizations) {
          console.log('Buy It Now clicked with customizations, using Add to Cart flow...');
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          // Set Buy It Now mode flag
          isBuyItNowMode = true;
          
          // Trigger the Add to Cart button click
          // This will go through the normal flow which adds main product + fees
          // Once fees are added, the flag will cause redirect to checkout
          addToCartButton.click();
          
          return false;
        }
        
        // No customizations, let Buy It Now proceed normally
      }, true); // Use capture phase to intercept before Shopify's handler
    }

    // Remove the old Buy It Now functions as they're no longer needed

    // Function to reset all customization toggles
    function resetAllToggles() {
      console.log('Resetting all customization toggles...');
      
      if (logoToggle) {
        logoToggle.checked = false;
        logoElement.enabled = false;
        logoElement.visible = false;
        logoImage = null; // Clear the logo image
        if (logoUploadSection) logoUploadSection.style.display = 'none';
        if (logoFileInput) logoFileInput.value = ''; // Clear file input
        if (hiddenLogoEnabled) hiddenLogoEnabled.value = '';
        if (hiddenLogoData) hiddenLogoData.value = '';
        if (hiddenLogoUrl) hiddenLogoUrl.value = '';
        if (hiddenLogoPrice) hiddenLogoPrice.value = '';
      }
      
      if (giftWrapToggle) {
        giftWrapToggle.checked = false;
        if (hiddenGiftWrap) hiddenGiftWrap.value = '';
        if (hiddenGiftWrapPrice) hiddenGiftWrapPrice.value = '';
      }
      
      if (markersToggle) {
        markersToggle.checked = false;
        if (hiddenMarkers) hiddenMarkers.value = '';
        if (hiddenMarkersPrice) hiddenMarkersPrice.value = '';
      }
      
      // Re-render canvas to reflect changes
      renderCanvas();
    }

    // Setup the Buy It Now interceptor after a delay to ensure DOM is ready
    setTimeout(setupBuyItNowInterceptor, 500);
    
    // Listen for checkout button clicks in cart drawer to reset toggles
    document.addEventListener('click', function(e) {
      var checkoutBtn = e.target.closest('[data-cart-checkout-btn], [name="checkout"], form[action="/checkout"]');
      if (checkoutBtn) {
        console.log('Checkout button clicked, resetting toggles...');
        resetAllToggles();
      }
    }, true);
    
    // Also setup on variant change
    if (container) {
      var variantPicker = document.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('change', function() {
          setTimeout(setupBuyItNowInterceptor, 500);
        });
      }
    }

    // Load initial image
    if (previewImage && previewImage.src && previewImage.complete) {
      loadBaseImage(previewImage.src);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initCustomizer, 300);
    });
  } else {
    setTimeout(initCustomizer, 300);
  }

  // Update cart count when navigating back from checkout
  window.addEventListener('pageshow', function(event) {
    // event.persisted is true when page is loaded from cache (back button)
    if (event.persisted || (performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0]?.type === 'back_forward')) {
      console.log('Page loaded from cache (back button), updating cart...');
      
      // Reset customization toggles when coming back
      var customizerContainer = document.querySelector('.product-customizer');
      if (customizerContainer) {
        var logoToggle = customizerContainer.querySelector('.product-customizer__toggle-input');
        var giftWrapToggle = customizerContainer.querySelector('.product-customizer__gift-wrap-toggle');
        var markersToggle = customizerContainer.querySelector('.product-customizer__markers-toggle');
        var logoUploadSection = customizerContainer.querySelector('.product-customizer__logo-upload');
        var logoFileInput = customizerContainer.querySelector('.product-customizer__file-input');
        
        if (logoToggle) {
          logoToggle.checked = false;
          if (logoUploadSection) logoUploadSection.style.display = 'none';
          if (logoFileInput) logoFileInput.value = ''; // Clear file input
        }
        if (giftWrapToggle) giftWrapToggle.checked = false;
        if (markersToggle) markersToggle.checked = false;
        
        console.log('Customization toggles reset');
      }
      
      // Fetch current cart data and update cart drawer
      fetch('/cart.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          console.log('Cart item count:', cart.item_count);
          
          // Update cart count badges in header
          var cartCounts = document.querySelectorAll('.m-cart-count-bubble');
          cartCounts.forEach(function(cartCount) {
            if (cart.item_count > 0) {
              cartCount.textContent = cart.item_count;
              cartCount.classList.remove('m:hidden');
            } else {
              cartCount.classList.add('m:hidden');
            }
          });
          
          // Refresh cart drawer content
          if (window.MinimogSettings && window.MinimogSettings.routes) {
            return fetch(window.MinimogSettings.routes.cart + '?section_id=cart-drawer')
              .then(function(response) { return response.text(); })
              .then(function(responseText) {
                var html = new DOMParser().parseFromString(responseText, 'text/html');
                
                // Update cart items
                var newCartItems = html.querySelector('[data-minimog-cart-items]');
                var currentCartItems = document.querySelector('[data-minimog-cart-items]');
                if (newCartItems && currentCartItems) {
                  currentCartItems.innerHTML = newCartItems.innerHTML;
                  console.log('Cart items refreshed');
                }
                
                // Update discounts
                var newDiscounts = html.querySelector('[data-minimog-cart-discounts]');
                var currentDiscounts = document.querySelector('[data-minimog-cart-discounts]');
                if (newDiscounts && currentDiscounts) {
                  currentDiscounts.innerHTML = newDiscounts.innerHTML;
                }
                
                // Update subtotal
                var newSubtotal = html.querySelector('[data-cart-subtotal]');
                var currentSubtotal = document.querySelector('[data-cart-subtotal]');
                if (newSubtotal && currentSubtotal) {
                  currentSubtotal.innerHTML = newSubtotal.innerHTML;
                  console.log('Cart subtotal refreshed');
                }
                
                // Update empty state
                var cartDrawer = document.querySelector('m-cart-drawer');
                if (cartDrawer) {
                  cartDrawer.classList.toggle('m-cart--empty', cart.item_count === 0);
                }
              });
          }
        })
        .then(function() {
          // Trigger cart update event after everything is updated
          if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
            window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { 
              source: 'pageshow-navigation'
            });
          }
        })
        .catch(function(error) {
          console.error('Error updating cart on page navigation:', error);
        });
    }
  });
})();